"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _component = _interopRequireWildcard(require("../base/component"));

var _index = _interopRequireDefault(require("../input/index"));

var _index2 = _interopRequireDefault(require("../icon/index"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var PAGE_PRE_LEVEL = 5;
var clsPrefix = 'kui-pager';

var PageButton = function PageButton() {
  var _classNames;

  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    cur: false,
    num: 1,
    className: '',
    disabled: false,
    children: null,
    onClick: function onClick() {
      return null;
    }
  };
  var cur = props.cur,
      num = props.num,
      className = props.className,
      disabled = props.disabled;

  var onClick = function onClick() {
    if (!props.disabled) {
      props.onClick(props);
    }
  };

  if (num < 0) {
    return /*#__PURE__*/React.createElement("a", {
      className: "".concat(clsPrefix, "-page-button ").concat(clsPrefix, "-more")
    }, /*#__PURE__*/React.createElement(_index2["default"], {
      type: "more"
    }));
  }

  var text = props.children ? props.children : num;
  var cls = (0, _classnames["default"])("".concat(clsPrefix, "-page-button"), (_classNames = {}, _defineProperty(_classNames, "".concat(clsPrefix, "-cur"), cur), _defineProperty(_classNames, "".concat(clsPrefix, "-disabled"), disabled), _classNames), className);
  return /*#__PURE__*/React.createElement("a", {
    className: cls,
    onClick: onClick,
    role: "button",
    tabIndex: 0
  }, text);
};

var JumpPageButton = function JumpPageButton(_ref) {
  var totalPage = _ref.totalPage,
      onConfirm = _ref.onConfirm;
  var inputValue = '';

  var handleKeyPress = function handleKeyPress(e) {
    if (e.keyCode === 13) {
      var num = parseInt(inputValue, 10);
      if (isNaN(num) || num > totalPage || num < 1) return;
      onConfirm({
        num: num
      });
    }
  };

  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(clsPrefix, "-jump-page-button")
  }, /*#__PURE__*/React.createElement("span", null, "\u524D\u5F80"), /*#__PURE__*/React.createElement(_index["default"], {
    value: inputValue,
    onKeyPress: handleKeyPress,
    onChange: function onChange(_ref2) {
      var value = _ref2.value;
      inputValue = value;
    },
    className: "".concat(clsPrefix, "-page-input")
  }), /*#__PURE__*/React.createElement("span", null, "\u9875"));
};

var Pager = /*#__PURE__*/function (_KZUIComponent) {
  _inherits(Pager, _KZUIComponent);

  var _super = _createSuper(Pager);

  function Pager(props) {
    var _this;

    _classCallCheck(this, Pager);

    _this = _super.call(this, props);

    _this.autoBind('handleClick', 'handleInputConfirm', 'handlePageChange', 'getButtons');

    return _this;
  }

  _createClass(Pager, [{
    key: "initStateFromProps",
    value: function initStateFromProps(props) {
      return {
        curPage: props.curPage
      };
    }
  }, {
    key: "handlePageChange",
    value: function handlePageChange(num) {
      var _this2 = this;

      this.setState({
        curPage: num
      }, function () {
        var _this2$props$onPageCh, _this2$props;

        (_this2$props$onPageCh = (_this2$props = _this2.props).onPageChange) === null || _this2$props$onPageCh === void 0 ? void 0 : _this2$props$onPageCh.call(_this2$props, num);
      });
    }
  }, {
    key: "handleClick",
    value: function handleClick(_ref3) {
      var num = _ref3.num;
      this.handlePageChange(num);
    }
  }, {
    key: "handleInputConfirm",
    value: function handleInputConfirm(_ref4) {
      var num = _ref4.num;
      this.handlePageChange(num);
    }
  }, {
    key: "getButtons",
    value: function getButtons() {
      var totalPage = this.props.totalPage;
      var curPage = this.state.curPage;
      var buttons = [];
      var half = Math.floor((PAGE_PRE_LEVEL - 1) / 2);
      var leftPartStart = curPage - half > 0 ? curPage - half : 1;

      if (leftPartStart > 1) {
        buttons.push(1);

        if (leftPartStart > 2) {
          buttons.push(-1);
        }
      }

      for (var i = leftPartStart; i < curPage; i += 1) {
        buttons.push(i);
      }

      var rightPartEnd = curPage + (PAGE_PRE_LEVEL - (curPage - leftPartStart) - 1);
      var lastOne = Math.min(rightPartEnd, totalPage);

      for (var _i = curPage; _i <= lastOne; _i += 1) {
        buttons.push(_i);
      }

      if (rightPartEnd < totalPage) {
        if (rightPartEnd < totalPage - 1) {
          buttons.push(-2);
        }

        buttons.push(totalPage);
      }

      return buttons;
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props = this.props,
          className = _this$props.className,
          style = _this$props.style,
          totalPage = _this$props.totalPage,
          children = _this$props.children;
      var curPage = this.state.curPage;
      var cls = (0, _classnames["default"])(clsPrefix, className);
      var buttons = this.getButtons();

      if (totalPage === 0) {
        return null;
      }

      return /*#__PURE__*/React.createElement("div", {
        className: cls,
        style: style
      }, children, /*#__PURE__*/React.createElement("div", {
        className: "".concat(clsPrefix, "-pager-controls")
      }, /*#__PURE__*/React.createElement(PageButton, {
        key: "page-button-prev",
        className: "".concat(clsPrefix, "-prev"),
        num: curPage - 1,
        onClick: this.handleClick,
        disabled: curPage === 1
      }, /*#__PURE__*/React.createElement(_index2["default"], {
        type: "drop-left"
      })), buttons.map(function (num) {
        return /*#__PURE__*/React.createElement(PageButton, {
          key: "page-button-".concat(num),
          num: num,
          cur: num === curPage,
          onClick: _this3.handleClick
        });
      }), /*#__PURE__*/React.createElement(PageButton, {
        key: "page-button-next",
        className: "".concat(clsPrefix, "-next"),
        num: curPage + 1,
        onClick: this.handleClick,
        disabled: curPage === totalPage
      }, /*#__PURE__*/React.createElement(_index2["default"], {
        type: "drop-right"
      })), totalPage > PAGE_PRE_LEVEL + 2 ? /*#__PURE__*/React.createElement(JumpPageButton, {
        totalPage: totalPage,
        onConfirm: this.handleInputConfirm
      }) : null));
    }
  }]);

  return Pager;
}(_component["default"]); // Pager.propTypes = {
//     totalPage: PropTypes.number.isRequired,
//     curPage: PropTypes.number.isRequired,
//     onPageChange: PropTypes.func,
// };
// Pager.defaultProps = {
//     onPageChange: null,
// };


_defineProperty(Pager, "defaultProps", _objectSpread(_objectSpread({}, _component.baseDefaultProps), {}, {
  onPageChange: function onPageChange() {
    return null;
  }
}));

var _default = Pager;
exports["default"] = _default;